module.exports = __webpack_public_path__ + "static/media/Foto 2 OEFA.f45ae7ea.jpg";